import React from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuthState } from 'react-firebase-hooks/auth'
import { auth, db } from '../firebaseconfig'

export const Usercard = ({totalTests}) => {
    const [user] = useAuthState(auth);
  return (
    <div className="user-info">
    <div className="user">
        <div className="picture">
            <AccountCircleIcon />
        </div>
        <div className="info">
            <div className="email">
                {user.email}
            </div>
            <div className="joined-at">
                {user.metadata.creationTime}
            </div>
        </div>
    </div>
    <div className="total-tests-taken">
        <span>
            Total Test Taken - {totalTests}
        </span>
    </div>
</div>
  )
}
